module.exports = __webpack_public_path__ + "static/img/a122.35fb7b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a122.jpg
// module id = jnuf
// module chunks = 0